<template>
  <div>
    <a-modal v-model="visible" title="Edit Room" onOk="handleOk" :width="this.settings['isMobileView'] ? 480 : 720">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleEdit">Update</a-button>
      </template>

      <a-form class="mb-4" :form="form">

        <div class="row">
          <div class="col-12 col-md-4">
            <a-form-item label="Select Hostel" required>
              <a-select
                size="default"
                v-model="selectedHostel"
                placeholder="Select Hostel"
                optionFilterProp="children"
                style="width: 100%"
                @change="handleHostelBlocks"
                :filterOption="false"
                :defaultValue="undefined"
              >
                <a-select-option :value="0">
                  Select Hostel
                </a-select-option>
                <template v-for="item in hostel">
                  <a-select-option :key="item.id" :value="item.id">
                    {{ item.name }}
                  </a-select-option>
                </template>
              </a-select>
            </a-form-item>
          </div>
          <div class="col-12 col-md-4">
            <a-spin :spinning="blockSpinning">
              <a-form-item label="Select Block" required>
                <a-select
                  size="default"
                  v-model="selectedBlock"
                  placeholder="Select Block"
                  optionFilterProp="children"
                  style="width: 100%"
                  :filterOption="false"
                  :defaultValue="undefined"
                  :disabled="!selectedHostel"
                >
                  <a-select-option :value="0">
                    Select Block
                  </a-select-option>
                  <template v-for="block in blocks">
                    <a-select-option :key="block.id" :value="block.id">
                      {{ block.name }}
                    </a-select-option>
                  </template>
                </a-select>
              </a-form-item>
            </a-spin>
          </div>
          <div class="col-12 col-md-4">
            <a-form-item label="Select Facility">
              <a-select
                placeholder="Select Facility"
                v-decorator="['facility_id', { rules: [{ required: true, message: 'Please select a facility!' } ] }]"
                @change="getfacilities"
              >
                <a-select-option v-for="facility in selectedFacility" :key="facility" :value="facility.id">{{ facility.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-6">
            <a-form-item label="Room Number">
              <a-input
                placeholder="Room Number"
                v-decorator="['room_number', {rules: [{ required: true, message: 'Please input a room number!' }]}]"
              />
            </a-form-item>
          </div>
          <div class="col-12 col-md-6">
            <a-form-item label="Capacity">
              <a-input-number
                placeholder="Room Capacity"
                :min="1"
                v-decorator="['room_capacity',{rules: [{ required: true, message: 'Please input capacity!'}]}]"
                style="width: 100%"
              />
            </a-form-item>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-6">
            <a-form-item label="Room Type">
              <a-select v-decorator="['type', { rules: [{ required: true, message: 'Room type is required!!' }] } ]" placeholder="Room Type">
                <a-select-option v-for="roomType in roomTypes" :value="roomType.value" :key="roomType.value">
                  {{ roomType.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </div>
          <div class="col-12 col-md-6">
            <a-form-item label="Room Status">
              <a-select v-decorator="['status', { rules: [{ required: false, message: 'Room status is required!!' }] } ]" placeholder="Room Status">
                <a-select-option v-for="status in roomStatus" :value="status.value" :key="status.value">
                  {{ status.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </div>
        </div>

        <a-form-item label="Description">
          <a-textarea placeholder="Description" :autosize="{minRows: 2}" v-decorator="['description']" />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { roomTypes, roomStatus } from '@/services/globaldata'
export default {
  name: 'EditRoom',
  data: function () {
    return {
      form: this.$form.createForm(this),
      visible: false,
      loading: false,
      oldrecord: {},
      newrecord: {},
      selectedFacility: [],
      hostel: [],
      blocks: [],
      selectedHostel: 0,
      selectedBlock: 0,
      blockSpinning: false,
      roomTypes,
      roomStatus,
    }
  },
  computed: {
    ...mapState(['settings', 'user']),
  },
  mounted: function () {
    this.$eventBus.$on('openEditForm', this.showForm)
    this.getHostels()
    this.getfacilities()
  },
  methods: {
    getHostels: function() {
      this.$http.get(`/api/hostel`)
        .then(({ data }) => {
          this.hostel = data.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleHostelBlocks(value) {
      this.selectedBlock = 0
      if (value !== null) {
        this.selectedHostel = value
        this.blockSpinning = true
        this.getBlocks(value)
      }
    },
    getBlocks: function(value) {
      this.$http.get(`/api/hostel/blocks/${value}`)
        .then(({ data }) => {
          this.blocks = data
          this.blockSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    getfacilities: function() {
      this.$http.get(`/api/hostel/facility/all`)
        .then(({ data }) => {
          this.selectedFacility = data.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    showForm: function(record) {
      this.visible = true
      this.getHostels(record.hostel.id)
      this.getBlocks(record.hostel.id)
      this.getfacilities(record.facility.id)
      this.oldrecord = record
      setTimeout(() => {
        this.form.setFieldsValue({
          'hostel_id': record.hostel.id,
          'block_id': record.block.id,
          'facility_id': record.facility.id,
          'room_number': record.room_number,
          'room_capacity': record.capacity,
          'type': record.type,
          'status': record.status,
          'description': record.description,
        })
        this.selectedHostel = record.hostel.id
        this.selectedBlock = record.block.id
      }, 50)
    },
    handleCancel(e) {
      this.visible = false
      this.form.resetFields()
    },
    handleEdit() {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$http
            .patch(`/api/hostel/room/${this.oldrecord.id}`, {
              hostel_id: this.selectedHostel,
              block_id: this.selectedBlock,
              facility_id: values.facility_id,
              room_number: values.room_number,
              capacity: values.room_capacity,
              description: values.description,
              type: values.type,
              status: values.status,
            })
            .then((resp) => {
              if (resp.status === 200) {
                this.loading = false
                this.visible = false
                this.$emit('onEdited')
                this.form.resetFields()
                this.$notification['success']({
                  message: 'Successfully edited',
                  description: 'Room edited successfully!',
                })
              } else {
                this.$notification['warning']({
                  message: 'Unknown Error',
                  description: 'There appears to be an error while submitting data.',
                })
              }
              this.form.resetFields()
            })
            .catch(error => {
              this.$neoNotify.error(error)
            })
        }
      })
      this.loading = false
    },
  },
}
</script>
